import { http } from './http';
import type { GlobalSearchResponseDto } from './types';

/** R19.3: GET /search/global?q= */
export const searchApi = {
  global(q: string): Promise<GlobalSearchResponseDto> {
    return http
      .get<GlobalSearchResponseDto>('/search/global', { params: { q: q.trim() } })
      .then((r) => r.data);
  },
};
